let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("covqK"), load("gQSWJ"), load("5xpVW")]).then(() => parcelRequire('babkf'));